/**
 * @returns true if the value is empty. Null and undefined also return true.
 */

export function isEmpty(value: string | Array<unknown> | null | undefined): boolean {
    return value === null || value === undefined || value.length === 0;
}
